/* eslint-disable @typescript-eslint/no-explicit-any */
import { Checkbox, FormError } from '@kcftech/design-system';
import { CreateNotificationSubscriptionFormInputProps } from 'pages/Settings/NotificationSubscriptions/form/types';
import {
    NotificationTriggerTable,
    NotificationTriggerTableWrapper,
} from 'pages/Settings/NotificationSubscriptions/NotificationTriggerTable';
import {
    notificationHardwareTypeName,
    validNotificationHardwareTypes,
} from 'pages/Settings/NotificationSubscriptions/shared';
import { Controller, FieldError, useFormState } from 'react-hook-form';

export function HardwareNotificationSubscriptionFormContent({
    form,
}: CreateNotificationSubscriptionFormInputProps) {
    const {
        control,
        trigger,
    } = form;

    const {
        errors,
        isSubmitted,
    } = useFormState({
        control,
    });

    const withFormValidate = (onChange: (e: unknown) => void) => (e: unknown) => {
        onChange(e);
        if (isSubmitted) {
            trigger();
        }
    };

    return (
        <NotificationTriggerTableWrapper>
            <NotificationTriggerTable
                rows={validNotificationHardwareTypes.map((type) => (
                    <tr key={type}>
                        <td>{notificationHardwareTypeName[type]}</td>
                        <td className="text-right">
                            <Controller
                                control={control}
                                name={
                                    `hardware.notificationTriggers.${type}.IsEmailEnabled` as const
                                }
                                render={({ field: { value, onChange } }) => (
                                    <Checkbox
                                        label=""
                                        onChange={withFormValidate(onChange)}
                                        checked={value}
                                        title={`Toggle emails for ${notificationHardwareTypeName[type]}`}
                                    />
                                )}
                            />
                        </td>
                        <td className="text-right">
                            <Controller
                                control={control}
                                name={
                                    `hardware.notificationTriggers.${type}.IsSmsEnabled` as const
                                }
                                render={({ field: { value, onChange } }) => (
                                    <Checkbox
                                        label=""
                                        onChange={withFormValidate(onChange)}
                                        checked={value}
                                        disabled
                                        title="Text notifications are not yet available for Hardware Alerts"
                                        // TODO: Uncomment after sms is implemented.
                                        // title={`Toggle text messages for ${notificationHardwareType[hardwareType]}`}
                                    />
                                )}
                            />
                        </td>
                    </tr>
                ))}
            />
            {/* Need to cast to unknown and then any because react hook form doesn't contain the correct type for errors */}
            {(errors as unknown as any)?.notificationTriggers?.map(
                (errText: FieldError) => (
                    <FormError message={errText.message} key={errText.message} />
                ),
            )}
            <FormError
                message={
                    (errors as unknown as any)?.notificationTriggerPhoneNumber?.message
                }
            />
        </NotificationTriggerTableWrapper>
    );
}
